var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z",
    fill: "#9258E7",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V16c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-2.86.68-4.5 3.24-4.5 6.32v5l-2 2v1h16v-1l-2-2zm-2 1h-8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z",
    fill: "#5D43CF"
  })));
}

export default __webpack_public_path__ + "97e94d97378193e7b9aded9338ec9e2b.svg";
export { SvgNotificationsIcon as ReactComponent };